import { Box, Grid } from "@mui/material";
import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./TrainingCenterDetails.scss";
import { styled } from "@mui/material/styles";
import green_icon from "../../../globals/assets/green_computer.svg";
import Switch from "@mui/material/Switch";
import Stack from "@mui/material/Stack";
import TrainingGridListing from "../../TrainingGridListing";
import TrainingListingFilter from "../../TrainingListingFilter";
import { toast } from "react-toastify";
import * as XLSX from "xlsx";
import WeekDays from "../../weekDays";
import TCCardView from "../CardView";
import Button from "../../common/Button";
import SearchBar from "../../common/searchBar";
import CardView from "../CardView";
import { useDispatch, useSelector } from "react-redux";
import closeImg from "../../../Images/closed.png";
import blueUserIcon from "../../../Images/blueUserIcon.png";
import {
  settrainingCenterID,
  showtrainingDetails,
} from "../../../redux/features/trainingCenter";
import CONSTANTURL from "../../../globals/common_utilities/constanturls";
import axios from "../../../globals/common_utilities/axios_old";
import { API } from "../../../globals/constants";
import Dropdown from "../../../components/common/Dropdown";
import { getTimezoneOption } from "../../../globals/common_utilities/timezoneListing";

const TrainingCenterDetails = (props) => {
  const { res, ondeleteClick } = props;
  let studioID = useSelector((state) => state.trainingCenterDetails?.id);
  const navigate = useNavigate();
  const [selectedFile, setSelectedFile] = useState();
  const [uploadData, setUploadData] = useState([]);
  const [errorMessage, setErrorMessage] = useState([]);
  const [uploadFilterData, setuploadFilterData] = useState([]);
  const [detailArray, setDetailArray] = useState([]);
  const [instruct, setinstruct] = useState([]);
  const [flag, setFlag] = useState(true);
  let detail = res.filter((res) => {
    return res.id === studioID;
  });
  let title = detail[0]?.studio_name;
  let titlelength = title?.length;
  let slicedTitle = title?.slice(0, 40);
  const [getTimeZoneList, setTimeZoneList] = useState();

  const TimeZoneFun = async () => {
    let timezone = await getTimezoneOption();
    setTimeZoneList(timezone);
  };

  const params = {
    role_id: "3",
    is_active: true,
  };

  const trainingCeneterList = async () => {
    // setFlag(!flag);
    console.log(detail[0]?.id, ":::::detail");
    const response = await axios(
      "GET",
      CONSTANTURL[process.env.REACT_APP_CUSTOM_ENV].LOGIN +
        API.END_POINTS.USERS +
        `?` +
        `studio_id=${detail[0]?.id}`,
      params,
      {},
      {}
    ).then((response) => {
      console.log("TrainingCenter", response.data.data.rows);
      setinstruct(response.data.data.rows);
    });
  };

  const dispatch = useDispatch();

  // const AntSwitch = styled(Switch)(({ theme }) => ({
  // 	width: 28,
  // 	height: 16,
  // 	padding: 0,
  // 	display: 'flex',
  // 	'&:active': {
  // 		'& .MuiSwitch-thumb': {
  // 			width: 15,
  // 		},
  // 		'& .MuiSwitch-switchBase.Mui-checked': {
  // 			transform: 'translateX(9px)',
  // 		},
  // 	},
  // 	'& .MuiSwitch-switchBase': {
  // 		padding: 2,
  // 		'&.Mui-checked': {
  // 			transform: 'translateX(12px)',
  // 			color: '#0C0D16',
  // 			'& + .MuiSwitch-track': {
  // 				opacity: 1,
  // 				backgroundColor: theme.palette.mode === 'dark' ? 'white' : 'white',
  // 			},
  // 		},
  // 	},
  // 	'& .MuiSwitch-thumb': {
  // 		boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
  // 		width: 12,
  // 		height: 12,
  // 		borderRadius: 6,
  // 		transition: theme.transitions.create(['width'], {
  // 			duration: 200,
  // 		}),
  // 	},
  // 	'& .MuiSwitch-track': {
  // 		borderRadius: 16 / 2,
  // 		opacity: 1,
  // 		backgroundColor:
  // 			theme.palette.mode === 'dark' ? 'rgba(0,0,0,.25)' : 'rgba(0,0,0,.25)',
  // 		boxSizing: 'border-box',
  // 	},
  // }));
  useEffect(() => {
    trainingCeneterList();
  }, [detail[0]]);

  useEffect(() => {
    TimeZoneFun();
  }, []);

  return (
    <>
      <div id="TrainingCenterDetails">
        <Box className="TrainingDetailsListMainContainer">
          <Grid container columnSpacing={2}>
            <Grid item xs={12} sm={12} md={8} lg={8}>
              <div className="detailsContainer">
                <Box className="childDetailsContainer">
                  <Box className="containerMargin">
                    <Grid container>
                      <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Box className="medium_f_bold">
                          {titlelength > 40
                            ? `${slicedTitle}...`
                            : detail[0]?.studio_name}
                          {/* {detail[0]?.studio_name} */}
                        </Box>
                      </Grid>
                      <Grid
                        item
                        xs={11}
                        sm={5}
                        md={5}
                        lg={5}
                        justifyContent="start"
                      >
                        <span className="TrainingDetailsUpcoming medium_f_bold">
                          {detail[0]?.location?.address}
                        </span>
                      </Grid>
                      <Grid item xs={1} sm={1} md={1} lg={1}>
                        <Stack
                          justifyContent="flex-end"
                          alignItems="flex-end"
                          onClick={() => {
                            // alert();
                            dispatch(showtrainingDetails(false));
                            // console.log('name', res.id);
                          }}
                        >
                          <img src={closeImg} className="close" />
                        </Stack>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="containerMargin">
                    <Grid container columnSpacing={4}>
                      <Grid item xs={12} sm={6} md={6} lg={4}>
                        <Box className="medium_f training_details_page_instructor_name">
                          Contact Person -
                          <span className="medium_f_bold">
                            {detail[0]?.admin_name}
                          </span>
                        </Box>
                      </Grid>
                      {/* <Grid item xs={12} sm={6} md={6} lg={4}>
                        <Box className="medium_f">
                          Contact no -
                          <span className="medium_f_bold">
                            {detail[0]?.contact_no}
                          </span>
                        </Box>
                      </Grid> */}
                      <Grid item xs={0} sm={6} md={6} lg={6}>
                        <Box className="medium_f">
                          Email ID -
                          <span className="medium_f_bold">
                            {detail[0]?.email}
                          </span>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="containerMargin">
                    {/* <Grid container columnSpacing={4}>
											<Grid item xs={12} sm={6} md={6} lg={6}>
												<Box className="medium_f training_details_page_instructor_name">
													Primary AWS Region -
													<span className="medium_f_bold">
														{detail[0]?.primary?.region_name}
													</span>
												</Box>
											</Grid>
											<Grid item xs={12} sm={6} md={6} lg={6}>
												<Box className="medium_f">
													Secondary AWS Region -
													<span className="medium_f_bold">
														{detail[0]?.secondary?.region_name}
													</span>
												</Box>
											</Grid>
											<Grid item xs={0} sm={0} md={6} lg={4}></Grid>
										</Grid> */}
                  </Box>
                  <Box className="containerMargin">
                    <Grid container columnSpacing={4}>
                      <Grid item xs={10.5} sm={10.5} md={10.5} lg={10.5}>
                        <Box className="small_f">{detail[0]?.about}</Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="containerMargin">
                    <Grid container rowSpacing={2} spacing={1}>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <Box className="startEndTrainingDetails">
                          <Stack direction="row" justifyContent="space-between">
                            <Stack className="fs-4">
                              No. of Scheduled Training :
                            </Stack>
                            <Stack className="fs-6">
                              {detail[0]?.training_count}
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <Box className="startEndTrainingDetails">
                          <Stack direction="row" justifyContent="space-between">
                            <Stack className="fs-4">
                              No. of Student Attended :
                            </Stack>
                            <Stack className="fs-6">
                              {detail[0]?.student_count}
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                      <Grid item xs={12} sm={12} md={4} lg={4}>
                        <Box className="startEndTrainingDetails">
                          <Stack direction="row" justifyContent="space-between">
                            <Stack className="fs-4">
                              No. of training Days :
                            </Stack>
                            <Stack className="fs-6">
                              {detail[0]?.training_days}
                            </Stack>
                          </Stack>
                        </Box>
                      </Grid>
                    </Grid>
                  </Box>
                  <Box className="machineRequiredContainer">
                    <Grid container rowSpacing={2} columnSpacing={2}>
                      {instruct.length > 0 ? (
                        instruct?.map((res) => {
                          return (
                            <Grid item flexWrap={"wrap"} xs={12} sm={6} md={4}>
                              <Stack className="instructorList">
                                <Stack>
                                  <Stack direction={"row"}>
                                    <img
                                      src={blueUserIcon}
                                      alt=""
                                      className="blueUserIcon"
                                    />
                                    <Stack
                                      className="medium_text"
                                      marginTop={"4%"}
                                    >
                                      {res?.name}
                                    </Stack>
                                  </Stack>
                                  <Stack className="tpDropDown">
                                    <Dropdown
                                      className="listDropDown"
                                      isDisabled={true}
                                      value={
                                        res?.zone &&
                                        getTimeZoneList?.filter(
                                          (zone) => res?.zone === zone?.value
                                        )
                                      }
                                      clearable
                                      options
                                      onChange
                                      selection
                                      placeholder
                                    />
                                  </Stack>
                                </Stack>
                              </Stack>
                            </Grid>
                          );
                        })
                      ) : (
                        <Stack className="centerDiv">No Record Found</Stack>
                      )}
                    </Grid>
                  </Box>
                </Box>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={4}
              lg={4}
              display={{ xs: "none", sm: "none", md: "flex" }}
            >
              <Box className="detailsContainer">
                <Grid container columnSpacing={4}>
                  <Grid item xs={12} sm={12} md={12} lg={12}>
                    <Stack direction="row" flexWrap="wrap">
                      <CardView
                        res={res}
                        lgWidth={12}
                        ondeleteClick={ondeleteClick}
                      />
                    </Stack>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </div>
    </>
  );
};
export default TrainingCenterDetails;
